import axios from "axios";

const setPvz = async ({commit}, pvz) => {
    commit('clearError')
    commit('setLoading', true)
    try {
        let params = new URLSearchParams();
        params.append('action', 'set_pvz');
        params.append('value', pvz);

        axios.put('/rest/pvz',params)
            .then(response => {
                commit('SET_PVZ', pvz)
                commit('SET_PVZ_OBJ', response.data)
            })
            .catch(error => {
                throw error
            })

        commit('setLoading', false)
    } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }
}

const setDelivDay = async({commit}, value) => {
    commit('clearError')
    commit('setLoading', true)
    try {
        let params = new URLSearchParams();
        params.append('action', 'set_deliv_day');
        params.append('value', value);
        axios.put('/rest/delivery', params)
        commit('SET_DELIV_DAY', value)
    } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }
    commit('setLoading', false)
}

const setDelivDaySam = async ({commit}, value) => {
    commit('clearError')
    commit('setLoading', true)
    try {
        let params = new URLSearchParams();
        params.append('action', 'deliv_day_sam');
        params.append('value', value);
        axios.put('/rest/delivery', params)
        commit('SET_DELIV_DAY_SAM', value)
        commit('setLoading', false)
    } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }
    commit('setLoading', false)
}

const setDelivInterval = async({commit}, payload) => {
    commit('clearError')
    commit('setLoading', true)
    try {
        let params = new URLSearchParams()
        params.append('action', 'set_interval')
        params.append('value', payload)
        axios.put('/rest/delivery', params)
        commit('SET_DELIV_INTERVAL', payload)
        commit('setLoading', false)
    } catch(error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error
    }
    commit('setLoading', false)
}

const setDelivTypeGroup = ({commit}, payload) => {
    commit('clearError')
    commit('setLoading', true)

    try {
        let params = new URLSearchParams()
        params.append('action', 'deliv_type')
        params.append('value', payload);
        axios.put('/rest/delivery',params)

        commit('SET_DELIV_TYPE_GROUP', payload)
        commit('setLoading', false)

    } catch(error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error;
    }

    commit('setLoading', false)
}

const setDelivTypeId =({commit}, payload) => {
    commit('clearError')
    commit('setLoading', true)

    try {

        let params = new URLSearchParams()
        params.append('action', 'set_dtype')
        params.append('value', payload)
        axios.put('/rest/delivery', params)
        commit('SET_DELIV_TYPE_ID', payload)
        commit('setLoading', false)

    } catch(error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error;
    }

    commit('setLoading', false)
}

const setUserInfo = ({commit}, payload) => {
    commit('clearError')
    commit('setLoading', true)

    try {
        let params = new URLSearchParams()
        params.append('action', 'set_user_info')
        params.append('value', payload)
        axios.put('/rest/delivery', params)
        commit('SET_USER_INFO', payload)
        commit('setLoading', false)
    } catch(error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error;
    }
    commit('setLoading', false)
}

const setPayType = ({commit}, payload) => {
    commit('clearError')
    commit('setLoading', true)

    try {
        let params = new URLSearchParams()
        params.append('action', 'set_pay_type')
        params.append('value', payload)
        axios.put('/rest/delivery', params)
        commit('SET_PAY_TYPE', payload)
        commit('setLoading', false)
    } catch(error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error;
    }

    commit('setLoading', false)
}

const getPvzs = async({commit}) => {
    commit('clearError')
    commit('setLoading', true)

    try {
        let params = new URLSearchParams()
        const response = await axios.get('/rest/get-pvzs', params)
        commit('SET_PVZS', response.data.pvz)
        commit('SET_COORDINATES', response.data.coordinates)
        commit('setLoading', false)
    } catch(error) {
        commit('setLoading', false)
        commit('setError', error.message)
        throw error;
    }
}

export default {
    setPvz,
    setDelivDay,
    setDelivDaySam,
    setDelivInterval,
    setDelivTypeGroup,
    setDelivTypeId,
    setUserInfo,
    setPayType,
    getPvzs
}
